import { render } from "./Top3News.vue?vue&type=template&id=442c9fa1&scoped=true"
import script from "./Top3News.vue?vue&type=script&lang=js"
export * from "./Top3News.vue?vue&type=script&lang=js"

import "./Top3News.vue?vue&type=style&index=0&id=442c9fa1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442c9fa1"]])

export default __exports__